var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wow fadeInLeft relative z-10" }, [
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "day count" }, [
        _vm._v("\n            " + _vm._s(_vm.countdownDays) + "\n        "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "lbl lbl-day" }, [
        _vm._v("\n            DAYs\n        "),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "hour count" }, [
        _vm._v("\n            " + _vm._s(_vm.countdownHours) + "\n        "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "lbl lbl-hour" }, [
        _vm._v("\n            hours\n        "),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "min count" }, [
        _vm._v("\n            " + _vm._s(_vm.countdownMinutes) + "\n        "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "lbl lbl-minute" }, [
        _vm._v("\n            minutes\n        "),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "min count" }, [
        _vm._v("\n            " + _vm._s(_vm.countdownSeconds) + "\n        "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "lbl lbl-seconds" }, [
        _vm._v("\n            seconds\n        "),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }